import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=0dcecfc4&"
import script from "./Watchlist.vue?vue&type=script&lang=ts&"
export * from "./Watchlist.vue?vue&type=script&lang=ts&"
import style0 from "./Watchlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports